import { render, staticRenderFns } from "./AddEditDiscountCode.vue?vue&type=template&id=279513b1&scoped=true&"
import script from "./AddEditDiscountCode.vue?vue&type=script&lang=ts&"
export * from "./AddEditDiscountCode.vue?vue&type=script&lang=ts&"
import style0 from "./AddEditDiscountCode.vue?vue&type=style&index=0&id=279513b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279513b1",
  null
  
)

export default component.exports